<div class="flex h-[calc(100vh-8rem)] flex-col gap-3">
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white/90">WhatsApp · Bandeja</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        Conversaciones de los números asignados a tu usuario.
      </p>
    </div>
    <div class="flex flex-wrap items-center gap-2">
      <!-- Mis números: desplegable arriba en lugar de una columna fija, para dejarle todo
           el ancho al hilo. -->
      @if (!loadingPhones && phones.length > 0) {
        <div #phonesMenu class="relative">
          <button
            type="button"
            (click)="togglePhones()"
            [attr.aria-expanded]="phonesOpen"
            class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
          >
            <span class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Mis números
            </span>
            <span class="font-medium text-gray-900 dark:text-white">
              {{ selectedPhone?.displayPhoneNumber || 'Elegir número' }}
            </span>
            @if (phones.length > 1) {
              <span class="rounded-full bg-gray-100 px-1.5 text-[10px] font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-300">
                {{ phones.length }}
              </span>
            }
            <svg
              class="h-4 w-4 text-gray-400 transition-transform"
              [class.rotate-180]="phonesOpen"
              fill="none" stroke="currentColor" viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </button>

          @if (phonesOpen) {
            <ul
              class="absolute left-0 z-dropdown mt-1 max-h-72 w-72 max-w-[90vw] overflow-y-auto rounded-lg border border-gray-200 bg-white py-1 shadow-lg dark:border-gray-700 dark:bg-gray-900"
            >
              @for (p of phones; track p.id) {
                <li>
                  <button
                    type="button"
                    (click)="selectPhone(p.id)"
                    class="flex w-full flex-col items-start gap-0.5 px-3 py-2 text-left text-sm transition hover:bg-gray-50 dark:hover:bg-gray-800/60"
                    [class.bg-emerald-50]="selectedPhoneId === p.id"
                    [class.dark:bg-emerald-900\/20]="selectedPhoneId === p.id"
                  >
                    <span class="font-medium text-gray-900 dark:text-white">
                      {{ p.displayPhoneNumber }}
                    </span>
                    <span class="truncate text-xs text-gray-500 dark:text-gray-400">
                      {{ p.verifiedName || 'Sin nombre' }}
                    </span>
                  </button>
                </li>
              }
            </ul>
          }
        </div>
      }

      <button
        type="button"
        (click)="reloadConversations()"
        [disabled]="loadingPhones || loadingConversations || loadingMessages"
        class="inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
      >
        <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
        </svg>
        Recargar
      </button>
    </div>
  </div>

  @if (!loadingPhones && phones.length > 0) {
    <div class="rounded-xl border border-gray-200 bg-white p-3 dark:border-gray-800 dark:bg-gray-900">
      <button
        type="button"
        (click)="toggleStart()"
        class="flex w-full items-center justify-between text-left text-sm font-medium text-gray-700 dark:text-gray-200"
      >
        <span>Escribirle a un número nuevo</span>
        <span class="text-xs">{{ startOpen ? '▲' : '▼' }}</span>
      </button>

      @if (startOpen) {
        <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
          Como el cliente todavía no escribió, WhatsApp sólo permite arrancar con una plantilla aprobada.
          Si el número no está en el CRM, se crea el contacto automáticamente.
        </p>

        <div class="mt-3 grid gap-3 md:grid-cols-2">
          <div>
            <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
              Enviar desde
            </label>
            <select
              [(ngModel)]="startPhoneId"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            >
              @for (p of phones; track p.id) {
                <option [value]="p.id">{{ p.displayPhoneNumber }}</option>
              }
            </select>
          </div>

          <div>
            <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
              Teléfono del destinatario
            </label>
            <input
              type="text"
              [(ngModel)]="startTo"
              placeholder="+51 987 654 321"
              class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            />
          </div>

          <div class="md:col-span-2">
            <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
              Plantilla
            </label>
            @if (templatesLoading) {
              <p class="text-xs text-gray-500 dark:text-gray-400">Cargando plantillas…</p>
            } @else if (templatesError) {
              <div class="rounded-lg border border-dashed border-red-300 bg-red-50 px-3 py-4 text-xs text-red-700 dark:border-red-900/40 dark:bg-red-900/20 dark:text-red-300">
                {{ templatesError }}
                <button type="button" (click)="loadTemplates()" class="ml-1 font-medium underline">
                  Reintentar
                </button>
              </div>
            } @else if (approvedTemplates.length === 0) {
              <div class="rounded-lg border border-dashed border-amber-300 bg-amber-50 px-3 py-4 text-xs text-amber-800 dark:border-amber-900/40 dark:bg-amber-900/20 dark:text-amber-200">
                Esta cuenta no tiene ninguna plantilla aprobada, y sin una no se puede escribir
                primero: WhatsApp solo deja abrir la conversación con una plantilla.
                <a routerLink="/whatsapp/plantillas" class="font-medium underline">
                  Crear una plantilla
                </a>
                — hay sugeridas listas para dar de alta con un clic.
              </div>
            } @else {
              <select
                [(ngModel)]="selectedTemplateName"
                (ngModelChange)="onTemplateChange()"
                class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
              >
                <option value="">Elige una plantilla…</option>
                @for (t of approvedTemplates; track t.name + t.language) {
                  <option [value]="t.name">{{ t.name }} ({{ t.language }})</option>
                }
              </select>
            }
          </div>

          @if (selectedTemplate) {
            <div class="md:col-span-2 space-y-2">
              @if (needsHeaderText) {
                <input
                  type="text"
                  [(ngModel)]="headerParam"
                  placeholder="Valor de la cabecera"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                />
              }
              @if (needsHeaderMedia) {
                <div class="rounded-lg border border-dashed border-gray-300 px-3 py-2 dark:border-gray-700">
                  <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
                    {{ headerMediaLabel }}
                  </label>
                  <input
                    type="file"
                    [accept]="headerMediaAccept"
                    (change)="onHeaderFileChange($event)"
                    class="w-full text-xs text-gray-600 file:mr-3 file:rounded-md file:border-0 file:bg-gray-100 file:px-3 file:py-1.5 file:text-xs file:font-medium file:text-gray-700 dark:text-gray-300 dark:file:bg-gray-800 dark:file:text-gray-200"
                  />
                  @if (!headerFile) {
                    <p class="mt-1 text-xs text-amber-600 dark:text-amber-500">
                      Esta plantilla lleva cabecera de archivo: WhatsApp la rechaza si se envía sin él.
                    </p>
                  }
                </div>
              }
              @for (p of templateParams; track $index) {
                <input
                  type="text"
                  [(ngModel)]="templateParams[$index]"
                  [placeholder]="'Parámetro ' + ($index + 1)"
                  class="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
                />
              }
              <div class="rounded-lg bg-gray-50 px-3 py-2 text-xs text-gray-600 dark:bg-gray-800 dark:text-gray-300">
                <span class="font-medium">Vista previa:</span>
                <span class="whitespace-pre-wrap">{{ templatePreview }}</span>
              </div>
            </div>
          }
        </div>

        <div class="mt-3 flex justify-end">
          <button
            type="button"
            (click)="startConversation()"
            [disabled]="!canStart"
            class="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50"
          >
            @if (sending) { Enviando… } @else { Iniciar conversación }
          </button>
        </div>
      }
    </div>
  }

  @if (errorMessage) {
    <div class="flex items-start gap-3 rounded-lg bg-red-50 p-3 text-sm text-red-700 dark:bg-red-900/20 dark:text-red-300">
      <span class="flex-1">{{ errorMessage }}</span>
      <button type="button" (click)="errorMessage = null" class="text-red-500 hover:text-red-700">×</button>
    </div>
  }

  @if (loadingPhones) {
    <div class="rounded-xl border border-gray-200 bg-white p-8 text-center text-sm text-gray-500 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400">
      Cargando…
    </div>
  } @else if (phones.length === 0) {
    <div class="rounded-xl border border-gray-200 bg-white p-8 text-center dark:border-gray-800 dark:bg-gray-900">
      <p class="text-sm font-medium text-gray-900 dark:text-white">No tienes números asignados</p>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
        Pídele a tu administrador que te asigne uno desde Configuración de WhatsApp.
      </p>
    </div>
  } @else {
    <div class="flex flex-1 min-h-0 overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
      <!-- Lista de conversaciones -->
      <section class="flex w-72 min-h-0 flex-shrink-0 flex-col overflow-hidden border-r border-gray-200 dark:border-gray-800">
        <div class="flex-shrink-0 border-b border-gray-200 p-3 dark:border-gray-800">
          <p class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Conversaciones
          </p>

          <!-- Buscador. El endpoint no acepta término de búsqueda y las conversaciones ya
               están todas en memoria, así que filtra aquí sin pedir nada al backend. -->
          <div class="mt-2">
            <div class="relative">
              <svg class="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
                   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="7"></circle>
                <path stroke-linecap="round" d="M20 20l-3.5-3.5"></path>
              </svg>
              <input
                type="text"
                [ngModel]="busqueda"
                (ngModelChange)="buscar($event)"
                placeholder="Buscar nombre o número…"
                aria-label="Buscar conversaciones"
                class="w-full rounded-lg border border-gray-200 bg-gray-50 py-1.5 pl-8 pr-8 text-xs text-gray-800 placeholder-gray-400 focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
              />
              @if (busqueda) {
                <button
                  type="button"
                  (click)="limpiarBusqueda()"
                  aria-label="Limpiar búsqueda"
                  class="absolute right-1.5 top-1/2 flex h-5 w-5 -translate-y-1/2 items-center justify-center rounded-full text-gray-400 transition hover:bg-gray-200 hover:text-gray-600 dark:hover:bg-gray-700 dark:hover:text-gray-200"
                >
                  <svg class="h-3 w-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3">
                    <path stroke-linecap="round" d="M6 6l12 12M18 6L6 18"></path>
                  </svg>
                </button>
              }
            </div>
            @if (busqueda) {
              <p class="mt-1 text-[10px] text-gray-400 dark:text-gray-500">
                {{ conversacionesVisibles.length }} de {{ conversationsForSelectedPhone.length }}
              </p>
            }
          </div>
        </div>
        @if (loadingConversations) {
          <div class="p-4 text-sm text-gray-500 dark:text-gray-400">Cargando…</div>
        } @else if (conversationsForSelectedPhone.length === 0) {
          <div class="p-4 text-sm text-gray-500 dark:text-gray-400">
            No hay conversaciones para este número.
          </div>
        } @else if (conversacionesVisibles.length === 0) {
          <!-- Distinto del vacío de arriba: el número SÍ tiene conversaciones, lo que no
               encaja es lo buscado. -->
          <div class="p-4 text-sm text-gray-500 dark:text-gray-400">
            Ninguna conversación coincide con «{{ busqueda }}».
            <button type="button" (click)="limpiarBusqueda()"
                    class="mt-1 block font-medium text-emerald-600 hover:underline dark:text-emerald-400">
              Limpiar búsqueda
            </button>
          </div>
        } @else {
          <ul class="min-h-0 flex-1 overflow-y-auto divide-y divide-gray-100 dark:divide-gray-800">
            @for (c of conversacionesVisibles; track c.id) {
              <li>
                <button
                  type="button"
                  (click)="selectConversation(c)"
                  class="flex w-full flex-col items-start gap-1 px-3 py-2.5 text-left transition hover:bg-gray-50 dark:hover:bg-gray-800/60"
                  [class.bg-emerald-50]="selectedConversation?.id === c.id"
                  [class.dark:bg-emerald-900\/20]="selectedConversation?.id === c.id"
                >
                  <span class="flex w-full items-center gap-2 text-sm font-medium text-gray-900 dark:text-white">
                    <span class="min-w-0 truncate">{{ conversationTitle(c) }}</span>
                    <!-- Distingue de un vistazo el hilo que todavía no tiene ficha: con el
                         alta automática apagada son mayoría, y es lo que decide si hay que
                         crearla o no. -->
                    @if (!tieneContacto(c)) {
                      <span class="shrink-0 rounded-full bg-amber-100 px-1.5 py-0.5 text-[10px] font-medium text-amber-700 dark:bg-amber-900/40 dark:text-amber-300">
                        Sin ficha
                      </span>
                    }
                  </span>
                  <!-- Con nombre, el número pasa a la segunda línea: es lo que identifica el
                       hilo en Meta y lo que se teclea para buscarlo. -->
                  @if (c.contactName && c.waId) {
                    <span class="text-xs text-gray-500 dark:text-gray-400">
                      {{ conversationPhone(c) }}
                    </span>
                  }
                  <span class="text-xs text-gray-500 dark:text-gray-400">
                    @if (c.lastMessageAt) {
                      {{ c.lastMessageAt | date:'short' }}
                    } @else {
                      Sin mensajes recientes
                    }
                  </span>
                </button>
              </li>
            }
          </ul>
        }
      </section>

      <!-- Hilo + composer -->
      <section class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        @if (!selectedConversation) {
          <div class="flex flex-1 items-center justify-center p-8 text-sm text-gray-500 dark:text-gray-400">
            Selecciona una conversación para ver el hilo.
          </div>
        } @else {
          <header class="flex-shrink-0 border-b border-gray-200 p-3 dark:border-gray-800">
            <div class="flex flex-wrap items-start justify-between gap-2">
              <div class="min-w-0">
                <p class="text-sm font-semibold text-gray-900 dark:text-white">
                  {{ conversationTitle(selectedConversation) }}
                  @if (selectedConversation.contactName && selectedConversation.waId) {
                    <span class="ml-2 text-xs font-normal text-gray-500 dark:text-gray-400">
                      {{ conversationPhone(selectedConversation) }}
                    </span>
                  }
                </p>
                <p class="text-xs text-gray-500 dark:text-gray-400">
                  {{ windowMessage(selectedConversation) }}
                </p>
              </div>

              <!-- Con ficha se ofrece abrirla; sin ficha NO se enlaza a /contactos: no hay
                   id al que ir. En su lugar, el alta manual. -->
              @if (tieneContacto(selectedConversation)) {
                <button
                  type="button"
                  (click)="abrirFicha(selectedConversation)"
                  class="shrink-0 rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
                >
                  Ver ficha del contacto
                </button>
              } @else if (!crearContactoAbierto) {
                <button
                  type="button"
                  (click)="abrirCrearContacto()"
                  class="shrink-0 rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-emerald-700"
                >
                  Crear contacto
                </button>
              }
            </div>

            @if (!tieneContacto(selectedConversation)) {
              <div class="mt-3 rounded-lg bg-amber-50 p-3 text-xs text-amber-800 dark:bg-amber-900/20 dark:text-amber-300">
                @if (!crearContactoAbierto) {
                  Este número no tiene ficha en Contactos. Podés seguir conversando igual;
                  creá la ficha sólo si esta persona te interesa como contacto del CRM.
                } @else {
                  <p class="mb-2 font-medium">Crear la ficha de {{ conversationPhone(selectedConversation) }}</p>
                  <p class="mb-2">
                    El nombre es opcional: si lo dejás vacío, la ficha toma el nombre del
                    perfil de WhatsApp en cuanto la persona vuelva a escribir.
                  </p>
                  <div class="flex flex-wrap items-center gap-2">
                    <input
                      type="text"
                      [(ngModel)]="nombreNuevoContacto"
                      name="nombreNuevoContacto"
                      maxlength="150"
                      placeholder="Nombre y apellido (opcional)"
                      class="min-w-0 flex-1 rounded-lg border border-amber-300 bg-white px-3 py-1.5 text-xs text-gray-900 dark:border-amber-700 dark:bg-gray-800 dark:text-white"
                    />
                    <button
                      type="button"
                      (click)="crearContacto()"
                      [disabled]="creandoContacto"
                      class="rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-emerald-700 disabled:opacity-60"
                    >
                      {{ creandoContacto ? 'Creando…' : 'Crear contacto' }}
                    </button>
                    <button
                      type="button"
                      (click)="cerrarCrearContacto()"
                      [disabled]="creandoContacto"
                      class="rounded-lg border border-amber-300 px-3 py-1.5 text-xs font-medium text-amber-800 hover:bg-amber-100 disabled:opacity-60 dark:border-amber-700 dark:text-amber-300 dark:hover:bg-amber-900/40"
                    >
                      Cancelar
                    </button>
                  </div>
                }
              </div>
            }
          </header>

          <div
            #messagesScroll
            class="min-h-0 flex-1 overflow-y-auto bg-gray-50 p-4 dark:bg-gray-950"
          >
            @if (loadingMessages) {
              <p class="text-center text-sm text-gray-500 dark:text-gray-400">Cargando mensajes…</p>
            } @else if (messages.length === 0) {
              <p class="text-center text-sm text-gray-500 dark:text-gray-400">Sin mensajes aún.</p>
            } @else {
              <div class="flex flex-col gap-2">
                @for (m of messages; track m.id) {
                  <div
                    class="flex"
                    [class.justify-end]="m.direction === 'OUTBOUND'"
                    [class.justify-start]="m.direction !== 'OUTBOUND'"
                  >
                    <div
                      class="max-w-[70%] rounded-lg px-3 py-2 text-sm shadow-sm"
                      [class.bg-emerald-600]="m.direction === 'OUTBOUND'"
                      [class.text-white]="m.direction === 'OUTBOUND'"
                      [class.bg-white]="m.direction !== 'OUTBOUND'"
                      [class.text-gray-900]="m.direction !== 'OUTBOUND'"
                      [class.dark:bg-gray-800]="m.direction !== 'OUTBOUND'"
                      [class.dark:text-gray-100]="m.direction !== 'OUTBOUND'"
                    >
                      @if (m.type === 'text') {
                        <p class="whitespace-pre-wrap break-words">{{ m.body }}</p>
                      } @else if (isMediaMessage(m)) {
                        <!-- El adjunto se descarga aparte (exige token), asi que mientras
                             no este listo se muestra el tipo en vez de un icono roto. -->
                        @if (mediaUrlFor(m); as mediaUrl) {
                          @switch (m.type) {
                            @case ('image') {
                              <a [href]="mediaUrl" target="_blank" rel="noopener">
                                <img
                                  [src]="mediaUrl"
                                  [alt]="m.body || 'Imagen recibida'"
                                  class="max-h-64 max-w-full rounded"
                                />
                              </a>
                            }
                            @case ('sticker') {
                              <img [src]="mediaUrl" alt="Sticker" class="max-h-32 max-w-full" />
                            }
                            @case ('video') {
                              <video [src]="mediaUrl" controls class="max-h-64 max-w-full rounded"></video>
                            }
                            @case ('audio') {
                              <audio [src]="mediaUrl" controls class="w-56 max-w-full"></audio>
                            }
                            @default {
                              <a
                                [href]="mediaUrl"
                                [download]="mediaFilename(m)"
                                class="flex items-center gap-2 underline"
                              >
                                <span aria-hidden="true">📎</span>
                                <span class="break-all">{{ m.body || mediaFilename(m) }}</span>
                              </a>
                            }
                          }
                        } @else {
                          <p class="italic opacity-90">[{{ messageTypeLabel(m.type) }}]</p>
                        }
                        @if (m.body && m.type !== 'document') {
                          <p class="mt-1 whitespace-pre-wrap break-words">{{ m.body }}</p>
                        }
                      } @else {
                        <p class="italic opacity-90">[{{ messageTypeLabel(m.type) }}]</p>
                        @if (m.body) {
                          <p class="mt-1 whitespace-pre-wrap break-words">{{ m.body }}</p>
                        }
                      }
                      <div class="mt-1 flex items-center justify-end gap-1 text-[10px] opacity-80">
                        <span>{{ m.messageTimestamp | date:'shortTime' }}</span>
                        @if (m.direction === 'OUTBOUND') {
                          <span [ngClass]="statusClass(m.status)">{{ statusIcon(m.status) }}</span>
                        }
                      </div>
                      @if (failureReason(m); as reason) {
                        <!-- El motivo de Meta es lo unico que distingue "el numero no esta
                             en la lista de permitidos" de "la plantilla esta pausada". -->
                        <p class="mt-1 rounded bg-red-50 px-2 py-1 text-[11px] text-red-700 dark:bg-red-900/40 dark:text-red-200">
                          No se entregó: {{ reason }}
                        </p>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <footer class="flex-shrink-0 border-t border-gray-200 p-3 dark:border-gray-800">
            @if (isWindowOpen(selectedConversation)) {
              <!-- Ventana abierta: texto libre -->
              @if (attachment) {
                <!-- Vista previa antes de enviar: el asesor confirma que eligio el archivo
                     correcto, que es justo lo que no se puede deshacer una vez enviado. -->
                <div class="mb-2 flex items-center gap-3 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 dark:border-gray-700 dark:bg-gray-800">
                  @if (attachmentPreviewUrl) {
                    <img [src]="attachmentPreviewUrl" alt="" class="h-12 w-12 rounded object-cover" />
                  } @else {
                    <span class="text-xl" aria-hidden="true">📎</span>
                  }
                  <span class="flex-1 truncate text-xs text-gray-700 dark:text-gray-300">
                    {{ attachment.name }}
                  </span>
                  <button
                    type="button"
                    (click)="clearAttachment()"
                    [disabled]="sending"
                    class="text-gray-400 hover:text-red-500 disabled:opacity-50"
                    aria-label="Quitar adjunto"
                  >
                    ×
                  </button>
                </div>
              }

              <div class="flex items-end gap-2">
                <label
                  class="cursor-pointer rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
                  [class.pointer-events-none]="sending"
                  [class.opacity-50]="sending"
                  title="Adjuntar archivo"
                >
                  <span aria-hidden="true">📎</span>
                  <input
                    type="file"
                    class="hidden"
                    accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                    [disabled]="sending"
                    (change)="onAttachmentChange($event)"
                  />
                </label>
                <!-- Emojis. El panel se ancla al botón y se abre hacia arriba: el
                     redactor está pegado al borde inferior del panel, que recorta. -->
                <div #emojiMenu class="relative">
                  <button
                    type="button"
                    (click)="toggleEmoji()"
                    [disabled]="sending"
                    [attr.aria-expanded]="emojiOpen"
                    title="Emojis"
                    aria-label="Insertar emoji"
                    class="rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
                    [class.bg-gray-100]="emojiOpen"
                    [class.dark:bg-gray-800]="emojiOpen"
                  >
                    <span aria-hidden="true">😊</span>
                  </button>

                  @if (emojiOpen) {
                    <div
                      class="absolute bottom-full left-0 z-dropdown mb-2 max-h-64 w-72 max-w-[80vw] overflow-y-auto rounded-lg border border-gray-200 bg-white p-2 shadow-lg dark:border-gray-700 dark:bg-gray-900"
                    >
                      @for (g of emojiGroups; track g.label) {
                        <p class="px-1 pb-1 pt-2 text-[10px] font-medium uppercase tracking-wide text-gray-400 dark:text-gray-500">
                          {{ g.label }}
                        </p>
                        <div class="grid grid-cols-8 gap-0.5">
                          @for (e of g.emojis; track e) {
                            <button
                              type="button"
                              (click)="insertEmoji(e)"
                              [attr.aria-label]="'Insertar ' + e"
                              class="rounded p-1 text-lg leading-none hover:bg-gray-100 dark:hover:bg-gray-800"
                            >
                              {{ e }}
                            </button>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
                <textarea
                  #composerInput
                  [(ngModel)]="composerText"
                  (keydown)="onComposerKeydown($event)"
                  rows="2"
                  maxlength="4096"
                  [disabled]="sending"
                  [placeholder]="attachment ? 'Pie de foto (opcional)…' : 'Escribe un mensaje…'"
                  class="min-w-0 flex-1 resize-none rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 placeholder-gray-400 focus:border-emerald-500 focus:outline-none focus:ring-1 focus:ring-emerald-500 disabled:bg-gray-100 disabled:text-gray-500 dark:border-gray-700 dark:bg-gray-900 dark:text-white dark:disabled:bg-gray-800"
                ></textarea>
                <button
                  type="button"
                  (click)="send()"
                  [disabled]="!canSend"
                  class="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50"
                >
                  @if (uploadingMedia) { Subiendo… } @else if (sending) { Enviando… } @else { Enviar }
                </button>
              </div>
              <p class="mt-1 text-[10px] text-gray-400 dark:text-gray-500">
                Enter envía · Mayús + Enter hace salto de línea
              </p>
            } @else {
              <!-- Ventana cerrada: sólo plantillas aprobadas -->
              <p class="mb-2 rounded bg-amber-50 px-3 py-2 text-xs text-amber-800 dark:bg-amber-900/20 dark:text-amber-300">
                {{ windowMessage(selectedConversation) }} Podés escribirle con una plantilla aprobada.
              </p>

              @if (templatesLoading) {
                <p class="px-1 py-2 text-xs text-gray-500 dark:text-gray-400">Cargando plantillas…</p>
              } @else if (templatesError) {
                <div class="rounded-lg border border-dashed border-red-300 px-3 py-4 text-center text-xs text-red-700 dark:border-red-900/40 dark:text-red-300">
                  {{ templatesError }}
                  <button type="button" (click)="loadTemplates()" class="ml-1 font-medium underline">
                    Reintentar
                  </button>
                </div>
              } @else if (approvedTemplates.length === 0) {
                <div class="rounded-lg border border-dashed border-gray-300 px-3 py-4 text-center text-xs text-gray-500 dark:border-gray-700 dark:text-gray-400">
                  No hay plantillas aprobadas en esta cuenta, y con la ventana cerrada es lo
                  único que se puede enviar.
                  <a routerLink="/whatsapp/plantillas" class="ml-1 font-medium text-emerald-600 hover:underline dark:text-emerald-400">
                    Crear una
                  </a>
                  <button type="button" (click)="loadTemplates()" class="ml-1 text-emerald-600 hover:underline dark:text-emerald-400">
                    Reintentar
                  </button>
                </div>
              } @else {
                <div class="max-h-[50vh] space-y-2 overflow-y-auto">
                  <select
                    [(ngModel)]="selectedTemplateName"
                    (ngModelChange)="onTemplateChange()"
                    [disabled]="sending"
                    class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-900 dark:text-white"
                  >
                    <option value="">Elige una plantilla…</option>
                    @for (t of approvedTemplates; track t.name + t.language) {
                      <option [value]="t.name">{{ t.name }} ({{ t.language }})</option>
                    }
                  </select>

                  @if (selectedTemplate) {
                    @if (needsHeaderText) {
                      <input
                        type="text"
                        [(ngModel)]="headerParam"
                        [disabled]="sending"
                        placeholder="Valor de la cabecera"
                        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-900 dark:text-white"
                      />
                    }

                    @if (needsHeaderMedia) {
                      <div class="rounded-lg border border-dashed border-gray-300 px-3 py-2 dark:border-gray-700">
                        <label class="mb-1 block text-xs font-medium text-gray-700 dark:text-gray-300">
                          {{ headerMediaLabel }}
                        </label>
                        <input
                          type="file"
                          [accept]="headerMediaAccept"
                          [disabled]="sending"
                          (change)="onHeaderFileChange($event)"
                          class="w-full text-xs text-gray-600 file:mr-3 file:rounded-md file:border-0 file:bg-gray-100 file:px-3 file:py-1.5 file:text-xs file:font-medium file:text-gray-700 dark:text-gray-300 dark:file:bg-gray-800 dark:file:text-gray-200"
                        />
                        @if (!headerFile) {
                          <p class="mt-1 text-xs text-amber-600 dark:text-amber-500">
                            Esta plantilla lleva cabecera de archivo: WhatsApp la rechaza si se envía sin él.
                          </p>
                        }
                      </div>
                    }

                    @for (p of templateParams; track $index) {
                      <input
                        type="text"
                        [(ngModel)]="templateParams[$index]"
                        [disabled]="sending"
                        [placeholder]="'Parámetro ' + ($index + 1)"
                        class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 dark:border-gray-700 dark:bg-gray-900 dark:text-white"
                      />
                    }

                    <div class="rounded-lg bg-gray-50 px-3 py-2 text-xs text-gray-600 dark:bg-gray-800 dark:text-gray-300">
                      <span class="font-medium">Vista previa:</span>
                      <span class="whitespace-pre-wrap">{{ templatePreview }}</span>
                    </div>

                    <button
                      type="button"
                      (click)="sendTemplate()"
                      [disabled]="!templateReady || sending"
                      class="w-full rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700 disabled:opacity-50"
                    >
                      @if (uploadingMedia) {
                        Subiendo archivo…
                      } @else if (sending) {
                        Enviando…
                      } @else {
                        Enviar plantilla
                      }
                    </button>
                  }
                </div>
              }
            }
          </footer>
        }
      </section>
    </div>
  }
</div>
